import { render } from "./prospect-dashboard.vue?vue&type=template&id=f0968f56"
import script from "./prospect-dashboard.vue?vue&type=script&lang=js"
export * from "./prospect-dashboard.vue?vue&type=script&lang=js"

import "./prospect-dashboard.vue?vue&type=style&index=0&id=f0968f56&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__